import { buildModalRoute } from '@manager/modules/modals/routable/modal-routable-utils';
import { routeNames } from '@manager/router/route-names';
import type { RouteMetaConfig } from '@manager/types/router';

export const unitsRoutes: RouteMetaConfig[] = [
  {
    path: '/units',
    name: routeNames.unitOverview,
    component: () => import('./views/UnitListView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'units.view',
      listFilterName: 'units',
    },
    children: [
      buildModalRoute(
        {
          name: routeNames.unitCreate,
          path: 'create',
          meta: {
            requiresAuth: true,
            permission: 'units.create',
          },
          component: () => import('./views/UnitCreateView.vue'),
        },
        { fullscreen: true }
      ),
      buildModalRoute(
        {
          path: 'export',
          name: routeNames.unitExport,
          meta: {
            requiresAuth: true,
            permission: 'units.export',
          },
          component: () => import('./views/UnitExportView.vue'),
        },
        { fullscreen: false, width: 'unset' }
      ),
    ],
  },
  {
    path: '/units/:id(\\d+)',
    name: routeNames.unitDetails,
    component: () => import('./views/UnitDetailView.vue'),
    meta: {
      requiresAuth: true,
      permission: 'units.view',
    },
    children: [
      buildModalRoute(
        {
          path: 'edit/general',
          name: routeNames.unitEditGeneral,
          meta: {
            requiresAuth: true,
            permission: 'units.update',
          },
          component: () => import('./views/UnitEditGeneralForm.vue'),
        },
        { fullscreen: false }
      ),
      buildModalRoute(
        {
          path: 'edit/measurements',
          name: routeNames.unitEditMeasurements,
          meta: {
            requiresAuth: true,
            permission: 'units.update',
          },
          component: () => import('./views/UnitEditMeasurementsForm.vue'),
        },
        { fullscreen: false }
      ),
    ],
  },
];

export const unitRouteFactory = {
  unitDetails(unitId: number | string) {
    return {
      name: routeNames.unitDetails,
      params: {
        id: unitId,
      },
    };
  },
};
